export const CHATWOOT_SET_USER = 'CHATWOOT_SET_USER';
export const CHATWOOT_RESET = 'CHATWOOT_RESET';

export const ANALYTICS_IDENTITY = 'ANALYTICS_IDENTITY';
export const ANALYTICS_RESET = 'ANALYTICS_RESET';

// Standard conversion events for ad tracking
export const ANALYTIC_EVENTS = {
  // User lifecycle events
  SIGNUP_STARTED: 'Signup Started',
  SIGNUP_COMPLETED: 'Signup Completed',
  ACCOUNT_CREATED: 'Account Created',
  LOGIN: 'User Login',
  LOGOUT: 'User Logout',

  // Subscription/billing events
  TRIAL_STARTED: 'Trial Started',
  SUBSCRIPTION_STARTED: 'Subscription Started',
  SUBSCRIPTION_CANCELLED: 'Subscription Cancelled',
  PLAN_UPGRADED: 'Plan Upgraded',
  PLAN_DOWNGRADED: 'Plan Downgraded',
  PAYMENT_SUCCESSFUL: 'Payment Successful',
  PAYMENT_FAILED: 'Payment Failed',

  // Feature adoption events
  INBOX_CREATED: 'Inbox Created',
  AGENT_INVITED: 'Agent Invited',
  FIRST_CONVERSATION: 'First Conversation',
  CHANNEL_CONNECTED: 'Channel Connected',
  INTEGRATION_ENABLED: 'Integration Enabled',

  // Engagement events
  DASHBOARD_OPENED: 'Dashboard Opened',
  CONVERSATION_VIEWED: 'Conversation Viewed',
  MESSAGE_SENT: 'Message Sent',
  MACRO_USED: 'Macro Used',
  AUTOMATION_CREATED: 'Automation Created',

  // CRM/Deals events
  DEAL_CREATED: 'Deal Created',
  DEAL_WON: 'Deal Won',
  DEAL_LOST: 'Deal Lost',
  TASK_CREATED: 'Task Created',
  CONTACT_CREATED: 'Contact Created',
};

// Ecommerce event data helpers
export const createPurchaseEvent = ({
  value,
  currency = 'NGN',
  planName,
  subscriptionId,
  isTrial = false,
}) => ({
  value,
  currency,
  plan_name: planName,
  subscription_id: subscriptionId,
  is_trial: isTrial,
});

export const createSignupEvent = ({ method, accountId, email }) => ({
  method, // 'email', 'google', 'saml'
  account_id: accountId,
  email_hash: email ? btoa(email).slice(0, 16) : null, // hashed for privacy
});
